import React from 'react'
import { Typography, Paper, Box, Stack } from '@mui/material'
import PeopleIcon from '@mui/icons-material/People'
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'

const StatsMetricsCards = ({
  totalParticipants,
  allCheckin,
  verifiedPercentage,
  shirtsDistributed,
}) => {
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={{ xs: 1.5, sm: 2, md: 2.5 }}
      sx={{ mb: { xs: 2.5, sm: 3, md: 3.5 } }}>
      {/* Total Registrants */}
      <Box sx={{ width: { xs: '100%', sm: '33.333%' }, flex: { sm: '1 1 0' } }}>
        <Paper
          elevation={0}
          sx={{
            p: { xs: 2, sm: 2.5, md: 3 },
            borderRadius: 2,
            backgroundColor: (theme) =>
              theme.palette.mode === 'light' ? 'rgba(255, 255, 255, 1)' : 'rgba(18, 18, 18, 1)',
            border: (theme) =>
              `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.08)' : 'rgba(255, 255, 255, 0.12)'}`,
            boxShadow: (theme) =>
              theme.palette.mode === 'light'
                ? '0 2px 8px rgba(0, 0, 0, 0.08)'
                : '0 2px 8px rgba(0, 0, 0, 0.3)',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
          <Box>
            <Typography
              variant="body2"
              sx={{
                color: 'text.secondary',
                fontSize: { xs: '0.8125rem', sm: '0.875rem', md: '0.9375rem' },
                mb: { xs: 0.5, sm: 0.75, md: 1 },
                fontWeight: 500,
              }}>
              Total Registrants
            </Typography>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                color: 'text.primary',
                fontSize: { xs: '1.75rem', sm: '2rem', md: '2.25rem' },
              }}>
              {totalParticipants?.toLocaleString() || '0'}
            </Typography>
          </Box>
          <Box
            sx={{
              width: { xs: 48, sm: 56, md: 64 },
              height: { xs: 48, sm: 56, md: 64 },
              borderRadius: 2,
              backgroundColor: 'rgba(33, 150, 243, 0.1)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
            <PeopleIcon
              sx={{
                fontSize: { xs: '1.75rem', sm: '2rem', md: '2.25rem' },
                color: 'primary.main',
              }}
            />
          </Box>
        </Paper>
      </Box>

      {/* Verified */}
      <Box sx={{ width: { xs: '100%', sm: '33.333%' }, flex: { sm: '1 1 0' } }}>
        <Paper
          elevation={0}
          sx={{
            p: { xs: 2, sm: 2.5, md: 3 },
            borderRadius: 2,
            backgroundColor: (theme) =>
              theme.palette.mode === 'light' ? 'rgba(255, 255, 255, 1)' : 'rgba(18, 18, 18, 1)',
            border: (theme) =>
              `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.08)' : 'rgba(255, 255, 255, 0.12)'}`,
            boxShadow: (theme) =>
              theme.palette.mode === 'light'
                ? '0 2px 8px rgba(0, 0, 0, 0.08)'
                : '0 2px 8px rgba(0, 0, 0, 0.3)',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
          <Box>
            <Typography
              variant="body2"
              sx={{
                color: 'text.secondary',
                fontSize: { xs: '0.8125rem', sm: '0.875rem', md: '0.9375rem' },
                mb: { xs: 0.5, sm: 0.75, md: 1 },
                fontWeight: 500,
              }}>
              Verified
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  color: 'text.primary',
                  fontSize: { xs: '1.75rem', sm: '2rem', md: '2.25rem' },
                }}>
                {allCheckin?.toLocaleString() || '0'}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: 'text.secondary',
                  fontSize: {
                    xs: '0.8125rem',
                    sm: '0.875rem',
                    md: '0.9375rem',
                  },
                }}>
                ({verifiedPercentage}%)
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              width: { xs: 48, sm: 56, md: 64 },
              height: { xs: 48, sm: 56, md: 64 },
              borderRadius: 2,
              backgroundColor: 'rgba(255, 152, 0, 0.1)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
            <VerifiedUserIcon
              sx={{
                fontSize: { xs: '1.75rem', sm: '2rem', md: '2.25rem' },
                color: '#FF9800',
              }}
            />
          </Box>
        </Paper>
      </Box>

      {/* Shirts Distributed */}
      <Box sx={{ width: { xs: '100%', sm: '33.333%' }, flex: { sm: '1 1 0' } }}>
        <Paper
          elevation={0}
          sx={{
            p: { xs: 2, sm: 2.5, md: 3 },
            borderRadius: 2,
            backgroundColor: (theme) =>
              theme.palette.mode === 'light' ? 'rgba(255, 255, 255, 1)' : 'rgba(18, 18, 18, 1)',
            border: (theme) =>
              `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.08)' : 'rgba(255, 255, 255, 0.12)'}`,
            boxShadow: (theme) =>
              theme.palette.mode === 'light'
                ? '0 2px 8px rgba(0, 0, 0, 0.08)'
                : '0 2px 8px rgba(0, 0, 0, 0.3)',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
          <Box>
            <Typography
              variant="body2"
              sx={{
                color: 'text.secondary',
                fontSize: { xs: '0.8125rem', sm: '0.875rem', md: '0.9375rem' },
                mb: { xs: 0.5, sm: 0.75, md: 1 },
                fontWeight: 500,
              }}>
              Shirts Distributed
            </Typography>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                color: 'text.primary',
                fontSize: { xs: '1.75rem', sm: '2rem', md: '2.25rem' },
              }}>
              {shirtsDistributed?.toLocaleString() || '0'} /{' '}
              {totalParticipants?.toLocaleString() || '0'}
            </Typography>
          </Box>
          <Box
            sx={{
              width: { xs: 48, sm: 56, md: 64 },
              height: { xs: 48, sm: 56, md: 64 },
              borderRadius: 2,
              backgroundColor: 'rgba(76, 175, 80, 0.1)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
            <LocalShippingIcon
              sx={{
                fontSize: { xs: '1.75rem', sm: '2rem', md: '2.25rem' },
                color: '#4CAF50',
              }}
            />
          </Box>
        </Paper>
      </Box>
    </Stack>
  )
}

export default StatsMetricsCards
